<template>
  <v-container
    id="productAnalysisDetail"
    class="productAnalysisDetail px-0 py-0"
    fluid
  >
    <v-card flat class="rounded-0">
      <v-row class="mx-0 my-0">
        <v-card-title class="ml-4 product-analysis-detail-title">
          レポート詳細
        </v-card-title>
        <v-spacer></v-spacer>
        <v-btn
          class="mt-4 mr-6"
          size="large"
          color="primary"
          width="200"
          :disabled="loading"
          @click="generatePDF"
        >
          PDFダウンロード<v-icon>mdi-download</v-icon>
        </v-btn>
        <v-btn
          class="mt-4 mr-6"
          size="large"
          outlined
          color="primary"
          width="200"
          @click="goBackToList"
        >
          製品分析に戻る
        </v-btn>
      </v-row>
    </v-card>
    <!-- レポート詳細 -->
    <div v-if="report" class="product-analysis-detail">
      <v-card>
        <v-row class="mx-4 mb-4" dense>
          <v-col cols="6">
            <v-carousel
              v-if="imageUrls"
              class="carousel justify-self-center"
              height="375px"
            >
              <v-carousel-item
                v-for="(imageUrl, i) in imageUrls"
                :key="i"
                :src="imageUrl"
                :contain="true"
                active-class="carousel"
              >
              </v-carousel-item>
            </v-carousel>
            <v-slide-group show-arrows class="mt-2">
              <v-slide-item v-for="(imageUrl, i) in imageUrls" :key="i">
                <v-img
                  :src="imageUrl"
                  height="120px"
                  width="120px"
                  :contain="true"
                  class="slide-items"
                >
                </v-img>
              </v-slide-item>
            </v-slide-group>
          </v-col>
          <v-col cols="6" class="mt-n4">
            <v-card-text class="ml-n4 pb-0 report-no">
              {{ "Report #" + report.id }}
            </v-card-text>
            <v-card-title class="ml-n4 pt-1 font-weight-bold font-title">
              {{ report.info.name }}
            </v-card-title>
            <v-card color="rgba(244, 248, 255, 1)">
              <v-row>
                <v-col cols="5" class="pt-2 pb-2">
                  <v-card-title class="font-weight-bold pt-0 pb-0"
                    >契約</v-card-title
                  >
                </v-col>
                <v-spacer></v-spacer>
                <v-col cols="7" align-self="center" class="card-text pt-2 pb-2">
                  <v-card-text class="text--secondary pt-0 pb-0">{{
                    contractTypeLabel
                  }}</v-card-text>
                </v-col>
              </v-row>
              <v-row v-if="dumpReasonLabel == '-'">
                <v-col cols="5" class="pt-0 pb-2">
                  <v-card-title class="font-weight-bold pt-0 pb-0"
                    >プラン詳細</v-card-title
                  >
                </v-col>
                <v-spacer></v-spacer>
                <v-col cols="7" align-self="center" class="card-text pt-0 pb-2">
                  <v-card-text class="text--secondary pt-0 pb-0">{{
                    report.contract ? report.contract.name : "-"
                  }}</v-card-text>
                </v-col>
              </v-row>
              <v-row v-else>
                <v-col cols="5" class="pt-0 pb-2">
                  <v-card-title class="font-weight-bold pt-0 pb-0"
                    >シーン</v-card-title
                  >
                </v-col>
                <v-spacer></v-spacer>
                <v-col cols="7" align-self="center" class="card-text pt-0 pb-2">
                  <v-card-text class="text--secondary pt-0 pb-0">{{
                    dumpReasonLabel
                  }}</v-card-text>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="5" class="pt-0 pb-2">
                  <v-card-title class="font-weight-bold pt-0 pb-0"
                    >搬入開始日</v-card-title
                  >
                </v-col>
                <v-spacer></v-spacer>
                <v-col cols="7" align-self="center" class="card-text pt-0 pb-2">
                  <v-card-text class="text--secondary pt-0 pb-0">{{
                    report.info.formattedDumpDate
                  }}</v-card-text>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="5" class="pt-0 pb-4">
                  <v-card-title class="font-weight-bold pt-0 pb-0"
                    >データ更新日</v-card-title
                  >
                </v-col>
                <v-spacer></v-spacer>
                <v-col cols="7" align-self="center" class="card-text pt-0 pb-4">
                  <v-card-text class="text--secondary pt-0 pb-0">{{
                    report.formattedUpdatedAt
                  }}</v-card-text>
                </v-col>
              </v-row>
              <v-divider></v-divider>
              <v-row>
                <v-col cols="5" class="pt-4 pb-2">
                  <v-card-title class="font-weight-bold pt-0 pb-0"
                    >区分</v-card-title
                  >
                </v-col>
                <v-spacer></v-spacer>
                <v-col cols="7" align-self="center" class="card-text pt-4 pb-2">
                  <v-card-text class="text--secondary pt-0 pb-0">{{
                    itemTypeLabel
                  }}</v-card-text>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="5" class="pt-0 pb-2">
                  <v-card-title class="font-weight-bold pt-0 pb-0"
                    >社名</v-card-title
                  >
                </v-col>
                <v-spacer></v-spacer>
                <v-col cols="7" align-self="center" class="card-text pt-0 pb-2">
                  <v-card-text class="text--secondary pt-0 pb-0">{{
                    report.info.company.name
                  }}</v-card-text>
                </v-col>
              </v-row>
              <v-row v-if="report.info.itemCategory">
                <v-col cols="5" class="pt-0 pb-2">
                  <v-card-title class="font-weight-bold pt-0 pb-0"
                    >カテゴリー</v-card-title
                  >
                </v-col>
                <v-spacer></v-spacer>
                <v-col cols="7" align-self="center" class="card-text pt-0 pb-2">
                  <v-card-text class="text--secondary pt-0 pb-0">{{
                    report.info.itemCategory.name
                  }}</v-card-text>
                </v-col>
              </v-row>
              <v-row v-if="report.info.productBrand">
                <v-col cols="5" class="pt-0 pb-2">
                  <v-card-title class="font-weight-bold pt-0 pb-0"
                    >ブランド</v-card-title
                  >
                </v-col>
                <v-spacer></v-spacer>
                <v-col cols="7" align-self="center" class="card-text pt-0 pb-2">
                  <v-card-text class="text--secondary pt-0 pb-0">{{
                    report.info.productBrand.name
                  }}</v-card-text>
                </v-col>
              </v-row>
              <v-row v-if="report.wastes">
                <v-col cols="5" class="pt-0 pb-4">
                  <v-card-title class="font-weight-bold pt-0 pb-0"
                    >廃棄物</v-card-title
                  >
                </v-col>
                <v-spacer></v-spacer>
                <v-col cols="7" align-self="center" class="card-text pt-0 pb-4">
                  <v-card-text class="text--secondary pt-0 pb-0"
                    >{{ report.wastes[0].wasteName
                    }}{{ report.wastes[0].partWeight
                    }}{{ report.wastes[0].partWeightScale }}</v-card-text
                  >
                </v-col>
              </v-row>
              <v-divider></v-divider>
              <v-row v-if="report.wastes">
                <v-col cols="5" class="pt-4 pb-2">
                  <v-card-title class="font-weight-bold pt-0 pb-0"
                    >重量(総重量)</v-card-title
                  >
                </v-col>
                <v-spacer></v-spacer>
                <v-col cols="7" align-self="center" class="card-text pt-4 pb-2">
                  <v-card-text class="text--secondary pt-0 pb-0"
                    >{{ report.info.itemWeight
                    }}{{ report.info.itemWeightScale }} ({{
                      report.info.totalWeight
                    }}{{ report.info.totalWeightScale }})</v-card-text
                  >
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
        <v-divider></v-divider>
      </v-card>
    </div>
    <!-- リサイクルフロー -->
    <div class="product-analysis-detail">
      <v-card class="base_container rounded-0">
        <div class="summary_top">
          <div class="summary_text">リサイクルフロー</div>
        </div>
        <div v-show="!loading" id="chartdiv"></div>
        <v-row
          v-if="loading"
          class="mt-6 mx-4"
          align-content="center"
          justify="center"
        >
          データを取得中です
          <v-progress-linear
            color="#0e5df0"
            indeterminate
            rounded
            height="6"
          ></v-progress-linear>
        </v-row>
      </v-card>
    </div>
    <!-- 再資源率・リサイクルタイプ -->
    <div v-if="report" class="product-analysis-detail">
      <v-card>
        <RecyclePercentageAndTypeChart
          v-if="statisticData"
          v-bind:receivedData="statisticData"
          class="elevation-0 width-100"
        />
      </v-card>
    </div>
    <!-- CO2サマリー -->
    <div v-if="report" class="product-analysis-detail">
      <v-card>
        <div class="summary_top">
          <div class="summary_text">CO2サマリー</div>
        </div>
        <div class="summary_bottom">
          <CO2SummaryHorizontalBarChart
            v-if="statisticData"
            kindText="CO2排出量（選別前）"
            v-bind:receivedData="statisticData.wasteCo2InGramWithName"
            v-bind:itemWeightInGram="statisticData.wasteWeightInGramWithName"
            v-bind:colorSet="0"
            v-bind:fixedPoint="2"
          />
          <CO2SummaryHorizontalBarChart
            v-if="statisticData"
            kindText="CO2排出量（選別後）"
            v-bind:receivedData="statisticData.resultCo2InGramWithName"
            v-bind:itemWeightInGram="statisticData.resultWeightInGramWithName"
            v-bind:colorSet="1"
            v-bind:fixedPoint="2"
          />
        </div>
      </v-card>
    </div>
    <!-- 結果/改善ポイント -->
    <div v-if="report" class="product-analysis-detail">
      <v-card>
        <v-toolbar class="font-weight-bold tabs" flat height="10px">
          <template v-slot:extension>
            <v-tabs v-model="tabs" grow centered>
              <v-tabs-slider color="#0AAA4A" class="tab"></v-tabs-slider>
              <v-tab
                v-for="menu in menus"
                :href="`#tab-${menu.id}`"
                :key="menu.id"
                :disabled="report.conditionList.length == 0 && menu.id == 2"
                class="tab"
              >
                {{ menu.name }}
                <span v-if="menu.id == 2"
                  >({{ report.conditionList.length }})</span
                >
              </v-tab>
            </v-tabs>
          </template>
        </v-toolbar>
        <v-tabs-items v-model="tabs" class="overflow-y-auto">
          <v-tab-item value="tab-1">
            <ResultChartComponent
              v-if="statisticData"
              v-bind:receivedData="statisticData.resultRecycleTypeDataInGram"
              v-bind:receivedDataForPartsResult="
                statisticData.resultWeightInGramWithName
              "
              v-bind:reportId="reportId"
              v-bind:itemInfo="report.info"
            />
            <v-data-table
              v-if="report && report.resources"
              :headers="headersForResources"
              :items="report.resources"
              :items-per-page="10"
              no-data-text="該当するデータがありません"
              class="elevation-1"
              checkbox-color="#0e5df0"
              :sort-by="['partWeightLabel']"
              :sort-desc="[true]"
              multi-sort
            >
              <template v-slot:item.images="{ item }">
                <v-img
                  v-if="item.images"
                  :src="item.images[0].url"
                  class="images"
                  @click="onClickImage(item.images[0].url)"
                >
                </v-img>
                <v-img
                  v-else
                  src="../../assets/images/NoImage.png"
                  class="images"
                  @click="onClickImage()"
                >
                </v-img>
              </template>
            </v-data-table>
          </v-tab-item>
          <v-tab-item value="tab-2">
            <v-data-table
              v-if="report && report.conditionList"
              :headers="headersForConditions"
              :items="report.conditionList"
              :items-per-page="10"
              no-data-text="該当するデータがありません"
              class="elevation-1"
              checkbox-color="#0e5df0"
              multi-sort
              @click:row="goToDetailForImprovement"
            >
              <template v-slot:item.conditionImages="{ item }">
                <v-img
                  v-if="item.conditionImages && item.conditionImages.length > 0"
                  :src="item.conditionImages[0].url"
                  class="images"
                  @click="onClickImage(item.conditionImages[0].url)"
                >
                </v-img>
                <v-img
                  v-else
                  src="../../assets/images/NoImage.png"
                  class="images"
                  @click="onClickImage()"
                >
                </v-img>
              </template>
              <template v-slot:item.commentForImprovement="{ item }">
                <span v-if="item.commentForImprovement">あり</span>
                <span v-else>なし</span>
              </template>
            </v-data-table>
          </v-tab-item>
        </v-tabs-items>
      </v-card>
    </div>
    <div>
      <v-dialog
        v-model="showZoomedImageDialog"
        persistent
        scrollable
        max-width="964px"
      >
        <v-card height="fit-content" class="rounded-0">
          <v-toolbar color="#FFF" elevation="0">
            <v-spacer></v-spacer>
            <v-btn icon @click="showZoomedImageDialog = false">
              <v-icon class="tbm-primary icon-close">mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <div>
            <v-img v-if="zoomImageUrl" :src="zoomImageUrl" />
            <v-img v-else src="../../assets/images/NoImage.png" />
          </div>
          <v-divider class="mb-4"></v-divider>
          <v-row class="mr-0 ml-0 mt-4 mb-4 justify-center">
            <v-btn
              class="mx-2"
              size="large"
              color="primary"
              width="200"
              @click="showZoomedImageDialog = false"
            >
              戻る
            </v-btn>
          </v-row>
        </v-card>
      </v-dialog>
    </div>
  </v-container>
</template>

<script>
import ItemTypes from "../../consts/ItemTypes.js";
import ResultChartComponent from "../../components/productAnalysis/ResultChartComponent";
import RecyclePercentageAndTypeChart from "../../components/dashboard/RecyclePercentageAndTypeChart";
import CO2SummaryHorizontalBarChart from "../../components/dashboard/CO2SummaryHorizontalBarChart";
import utils from "../../mixins/utils.js";
import * as am5 from "@amcharts/amcharts5";
import * as am5flow from "@amcharts/amcharts5/flow";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
import am5themes_Responsive from "@amcharts/amcharts5/themes/Responsive";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

let series = null;

export default {
  name: "ProductAnalysisDetail",
  components: {
    ResultChartComponent,
    RecyclePercentageAndTypeChart,
    CO2SummaryHorizontalBarChart,
  },
  data() {
    return {
      report: null,
      reportId: null,
      companyHash: null,
      statisticData: null,
      imageUrls: [],
      menus: [
        { id: 1, name: "結果" },
        { id: 2, name: "指摘" },
      ],
      tabs: null,
      headersForResources: [
        {
          text: "画像",
          value: "images",
          width: "100px",
          height: "54px",
          sortable: false,
          align: "center",
        },
        {
          text: "再資源名",
          value: "resourceName",
          width: "111px",
          height: "54px",
        },
        {
          text: "種類",
          value: "resource.resourceCategory.name",
          width: "160px",
          height: "54px",
        },
        {
          text: "重量",
          value: "partWeightLabel",
          width: "97px",
          height: "54px",
        },
      ],
      headersForConditions: [
        {
          text: "画像",
          value: "conditionImages",
          width: "100px",
          height: "54px",
          sortable: false,
          align: "center",
        },
        {
          text: "タイトル",
          value: "conditionTitle",
          width: "111px",
          height: "54px",
        },
        {
          text: "アドバイス",
          value: "commentForImprovement",
          width: "160px",
          height: "54px",
        },
        { text: "担当者", value: "checkedBy", width: "148px", height: "54px" },
      ],
      dumpReasons: null,
      contractTypeLabel: null,
      dumpReasonLabel: null,
      itemTypeLabel: null,
      conditionId: null,
      showZoomedImageDialog: false,
      zoomImageUrl: null,
      chartHeight: "700px",
      loading: true,
    };
  },
  mixins: [utils],
  watch: {
    "report.contract"(newValue) {
      if (newValue) {
        if (this.report.contract.contractType == "GENERAL") {
          this.contractTypeLabel = "総合分析";
        } else if (this.report.contract.contractType == "EVENT") {
          this.contractTypeLabel = "イベント分析";
        } else if (this.report.contract.contractType == "SINGLE") {
          this.contractTypeLabel = "個別分析";
        } else {
          this.contractTypeLabel = "-";
        }
      } else {
        this.contractTypeLabel = "-";
      }
    },
    "report.info.dumpReason"(newValue) {
      const selectedDumpReason = this.dumpReasons.filter(function (dumpReason) {
        if (dumpReason.value == newValue) return dumpReason;
      });
      this.dumpReasonLabel =
        selectedDumpReason.length == 0 ? "-" : selectedDumpReason[0].name;
    },
    "report.info.itemType"(newValue) {
      const selectedItemType = ItemTypes.filter(function (itemType) {
        if (itemType.value == newValue) return itemType;
      });
      this.itemTypeLabel = selectedItemType[0].name;
    },
  },
  async created() {
    if (
      this.$hasAllRequiredPermission(
        ["DASHBOARD:SELECT_COMPANY"],
        this.$store.state.auth.loginInfo
      ) &&
      this.$store.state.auth.selectedCompanyHash
    ) {
      this.companyHash = this.$store.state.auth.selectedCompanyHash;
    } else if (
      this.$store.state.auth.loginInfo &&
      this.$store.state.auth.loginInfo.company.hash
    ) {
      this.companyHash = this.$store.state.auth.loginInfo.company.hash;
    }
    this.reportId = Number(this.$route.query.reportId);
    this.loading = true;
    await this.getItemInfo();
    await this.getStatisticInfo();
    this.tabs = 1;
    await this.getDumpReasons();
  },
  methods: {
    async getDumpReasons() {
      await this.$axios
        .get("/circular-contract/dump-reasons/dashboard")
        .then((response) => {
          this.dumpReasons = response.data.content.generalDumpReasons;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async getItemInfo() {
      this.$axios
        .get("/circular-insight/dashboard/insight/items/" + this.reportId)
        .then(async (response) => {
          this.report = response.data.content;
          await this.setImageList(response.data.content.images);
          await this.formatDate();
          await this.setWasteResourceLabel();
          await this.setResourcesWeightLabel();
          await this.setCheckedBy();
          await this.setChart();
        })
        .catch((err) => {
          console.log(err);
          if (err.response.status == 401) {
            this.$store.dispatch("auth/logout");
            this.$router.push({ path: "/login", query: { logout: true } });
          } else {
            this.$router.push({ path: "/error/500" });
          }
        });
    },
    async getStatisticInfo() {
      this.$axios
        .get("/circular-insight/dashboard/statistics/items/" + this.reportId)
        .then((response) => {
          this.statisticData = response.data.content;
        })
        .catch((err) => {
          console.log(err);
          if (err.response.status == 401) {
            this.$store.dispatch("auth/logout");
            this.$router.push({ path: "/login", query: { logout: true } });
          } else {
            this.$router.push({ path: "/error/500" });
          }
        });
    },
    setImageList(images) {
      this.imageUrls = [];
      if (images.ImgFront) this.imageUrls.push(images.ImgFront.url);
      if (images.ImgBack) this.imageUrls.push(images.ImgBack.url);
      if (images.ImgLeft) this.imageUrls.push(images.ImgLeft.url);
      if (images.ImgRight) this.imageUrls.push(images.ImgRight.url);
      if (images.ImgLabel) this.imageUrls.push(images.ImgLabel.url);
    },
    formatDate() {
      if (this.report.info && this.report.info.dumpDate) {
        const [year, month, day] = this.report.info.dumpDate.split("-");
        this.report.info.formattedDumpDate = `${year}.${month}.${day}`;
      }
      if (this.report.updatedAt) {
        const [date] = this.report.updatedAt.split("T");
        const [year, month, day] = date.split("-");
        this.report.formattedUpdatedAt = `${year}.${month}.${day}`;
      }
    },
    setWasteResourceLabel() {
      if (this.report.wastes) {
        for (let i = 0; i < this.report.wastes.length; i++) {
          this.report.wastes[i].wasteName = this.report.wastes[i].waste
            .wasteAliasName
            ? this.report.wastes[i].waste.wasteAliasName
            : this.report.wastes[i].waste.name;
        }
      }
      if (this.report.resources) {
        for (let i = 0; i < this.report.resources.length; i++) {
          this.report.resources[i].resourceName = this.report.resources[i]
            .resource.resourceAliasName
            ? this.report.resources[i].resource.resourceAliasName
            : this.report.resources[i].resource.name;
        }
      }
    },
    setResourcesWeightLabel() {
      if (this.report.resources) {
        for (var i = 0; i < this.report.resources.length; i++) {
          this.report.resources[i].partWeightLabel =
            this.report.resources[i].partWeight +
            this.report.resources[i].partWeightScale;
        }
      }
    },
    setCheckedBy() {
      if (this.report.conditionList) {
        for (var i = 0; i < this.report.conditionList.length; i++) {
          this.report.conditionList[i].checkedBy =
            this.report.checkedBy.realName;
        }
      }
    },
    goBackToList() {
      this.$router.push({
        path: "/dashboard/productAnalysis",
      });
    },
    goToDetailForImprovement(condition) {
      if (!this.showZoomedImageDialog) {
        this.$router.push({
          path: "/dashboardDetail/productAnalysisDetailForImprovement",
          query: { reportId: this.reportId, conditionId: condition.id },
        });
      }
    },
    onClickImage(target) {
      this.showZoomedImageDialog = true;
      this.zoomImageUrl = target;
    },
    async setChart() {
      await am5.ready(function () {
        // Create root element
        am5.disposeAllRootElements();
        // https://www.amcharts.com/docs/v5/getting-started/#Root_element
        const root = am5.Root.new("chartdiv");

        // Set themes
        // https://www.amcharts.com/docs/v5/concepts/themes/
        root.setThemes([
          am5themes_Animated.new(root),
          am5themes_Responsive.new(root),
        ]);

        // Create series
        // https://www.amcharts.com/docs/v5/charts/flow-charts/
        series = root.container.children.push(
          am5flow.Sankey.new(root, {
            sourceIdField: "sourceId",
            sourceField: "sourceLabel",
            targetIdField: "targetId",
            targetLabelField: "targetLabel",
            valueField: "value",
            nodeWidth: 30,
            minSize: 0.002,
          })
        );

        // 角丸の見た目のnodeに変更
        series.nodes.rectangles.template.setAll({
          cornerRadiusTL: 4,
          cornerRadiusTR: 4,
          cornerRadiusBL: 4,
          cornerRadiusBR: 4,
          templateField: "nodeSettings",
        });

        // リサイクルだけLabelを左側に出すように変更
        series.nodes.labels.template.adapters.add("x", function (x, target) {
          if (target.dataItem.dataContext.depth == 3) return am5.percent(100);
        });
        series.nodes.labels.template.adapters.add(
          "centerX",
          function (centerX, target) {
            if (target.dataItem.dataContext.depth == 3) return am5.percent(100);
          }
        );
        series.nodes.labels.template.adapters.add("y", function (y, target) {
          if (
            target.dataItem.dataContext.depth == 1 ||
            target.dataItem.dataContext.depth == 3
          ) {
            return am5.percent(45);
          } else {
            return am5.percent(55);
          }
        });

        // TooltipのLabelをフォーマット
        series.links.template.setAll({
          tooltipText: "From: [bold]{sourceLabel}[/]\nTo: [bold]{targetLabel}",
          templateField: "linkSettings",
        });
      });
      // データを取得
      this.reflectSummaryData();
    },
    async reflectSummaryData() {
      // chartの高さを算出
      let resultNodeSize = this.report.resources.length;
      switch (true) {
        case resultNodeSize <= 5:
          this.chartHeight = "700px";
          break;
        case resultNodeSize > 5 && resultNodeSize <= 10:
          this.chartHeight = "1050px";
          break;
        case resultNodeSize > 10 && resultNodeSize <= 15:
          this.chartHeight = "1400px";
          break;
        case resultNodeSize > 15 && resultNodeSize <= 20:
          this.chartHeight = "1750px";
          break;
        case resultNodeSize > 20 && resultNodeSize <= 25:
          this.chartHeight = "2100px";
          break;
        case resultNodeSize > 25:
          this.chartHeight = "2450px";
          break;
      }
      // chart表示エリアの高さを動的に変更
      var element = document.querySelector(".base_container");
      element.style.height = this.chartHeight;
      // レポートデータを設定
      let reportData = JSON.parse(JSON.stringify(this.report));
      // 廃棄物の重量データを取得(1レポート1廃棄物の原則に則ったロジック)
      let wasteSummaryData = {};
      let totalWeightInKg = 0;
      if (reportData.info.totalWeightScale == "g") {
        totalWeightInKg = Number(reportData.info.totalWeight) / 1000;
      } else if (reportData.info.totalWeightScale == "t") {
        totalWeightInKg = Number(reportData.info.totalWeight) * 1000;
      } else {
        totalWeightInKg = Number(reportData.info.totalWeight);
      }
      wasteSummaryData[reportData.wastes[0].wasteName] = totalWeightInKg;
      // 単体重量合計を取得
      let partWeightTotalInGram = 0;
      reportData.resources.forEach((value) => {
        if (value.partWeightScale == "g") {
          partWeightTotalInGram += value.partWeight;
        } else if (value.partWeightScale == "kg") {
          partWeightTotalInGram += value.partWeight * 1000;
        } else {
          partWeightTotalInGram += value.partWeight * 1000000;
        }
      });
      // リサイクルタイプごとの再資源の重量データを取得
      let resultSummaryData = {};
      reportData.resources.forEach((value) => {
        // グラフ上の重量はkg表示に変更。
        let resultValueInKilograms = 0;
        let partWeightRatio = 0;
        if (value.partWeightScale == "g") {
          partWeightRatio = value.partWeight / partWeightTotalInGram;
        } else if (value.partWeightScale == "kg") {
          partWeightRatio = (value.partWeight * 1000) / partWeightTotalInGram;
        } else {
          partWeightRatio =
            (value.partWeight * 1000000) / partWeightTotalInGram;
        }
        if (reportData.info.totalWeightScale == "g") {
          resultValueInKilograms +=
            (reportData.info.totalWeight / 1000) * partWeightRatio;
        } else if (reportData.info.totalWeightScale == "t") {
          resultValueInKilograms +=
            reportData.info.totalWeight * 1000 * partWeightRatio;
        } else {
          resultValueInKilograms +=
            reportData.info.totalWeight * partWeightRatio;
        }
        if (
          Object.prototype.hasOwnProperty.call(
            resultSummaryData,
            value.recycleTypeDesc
          )
        ) {
          resultSummaryData[value.recycleTypeDesc] += resultValueInKilograms;
        } else {
          resultSummaryData[value.recycleTypeDesc] = resultValueInKilograms;
        }
      });
      // 廃棄物のnodeデータを作成(1レポート1廃棄物の原則に則ったロジック)
      let wasteNodesData = [];
      wasteNodesData.push({
        id:
          reportData.wastes[0].wasteName +
          " " +
          this.convertToFormattedNumber(
            wasteSummaryData[reportData.wastes[0].wasteName]
          ) +
          "kg",
        depth: 1,
        nodeSettings: { fill: am5.color(0xbe95ff) },
      });
      // 廃棄物~再資源~リサイクルタイプまでのデータを作成
      let wasteData = [];
      let resultNodesData = [];
      let resultData = [];
      reportData.resources.forEach((value) => {
        // 再資源の重量をkg表示に変更。
        let resultValueInKilograms = 0;
        let partWeightRatio = 0;
        if (value.partWeightScale == "g") {
          partWeightRatio = value.partWeight / partWeightTotalInGram;
        } else if (value.partWeightScale == "kg") {
          partWeightRatio = (value.partWeight * 1000) / partWeightTotalInGram;
        } else {
          partWeightRatio =
            (value.partWeight * 1000000) / partWeightTotalInGram;
        }
        if (reportData.info.totalWeightScale == "g") {
          resultValueInKilograms +=
            (reportData.info.totalWeight / 1000) * partWeightRatio;
        } else if (reportData.info.totalWeightScale == "t") {
          resultValueInKilograms +=
            reportData.info.totalWeight * 1000 * partWeightRatio;
        } else {
          resultValueInKilograms +=
            reportData.info.totalWeight * partWeightRatio;
        }
        let formattedResultValue =
          this.convertToFormattedNumber(resultValueInKilograms) + "kg";
        // 廃棄物~再資源のLink情報をセット
        wasteData.push({
          sourceId:
            reportData.wastes[0].wasteName +
            " " +
            this.convertToFormattedNumber(
              wasteSummaryData[reportData.wastes[0].wasteName]
            ) +
            "kg",
          sourceLabel:
            reportData.wastes[0].wasteName +
            " " +
            this.convertToFormattedNumber(
              wasteSummaryData[reportData.wastes[0].wasteName]
            ) +
            "kg",
          targetId: value.resourceName,
          targetLabel: value.resourceName + " " + formattedResultValue,
          value: resultValueInKilograms,
        });
        // 再資源のnodeデータを作成
        let resultNodeColor =
          value.recycleTypeDesc == "焼却" || value.recycleTypeDesc == "埋立"
            ? 0xca9898
            : 0x75c670;
        // 同じ名前のノードが既に存在する場合は追加しない
        if (!resultNodesData.some((n) => n.id === value.resourceName)) {
          resultNodesData.push({
            id: value.resourceName,
            depth: 2,
            nodeSettings: { fill: am5.color(resultNodeColor) },
          });
        }
        // 再資源~リサイクルタイプのLink情報をセット
        resultData.push({
          sourceId: value.resourceName,
          sourceLabel: value.resourceName + " " + formattedResultValue,
          targetId:
            value.recycleTypeDesc +
            " " +
            this.convertToFormattedNumber(
              resultSummaryData[value.recycleTypeDesc]
            ) +
            "kg",
          targetLabel: value.recycleTypeDesc + " " + formattedResultValue,
          value: resultValueInKilograms,
        });
      });
      // リサイクルタイプのnodeデータを作成
      let lastNodesData = [];
      let recycleNodeKeys = Object.keys(resultSummaryData);
      for (let i = 0; i < recycleNodeKeys.length; i++) {
        let recycleNodeColor =
          recycleNodeKeys[i] == "焼却" || recycleNodeKeys[i] == "埋立"
            ? 0x790000
            : 0x126311;
        lastNodesData.push({
          id:
            recycleNodeKeys[i] +
            " " +
            this.convertToFormattedNumber(
              resultSummaryData[recycleNodeKeys[i]]
            ) +
            "kg",
          depth: 3,
          nodeSettings: { fill: am5.color(recycleNodeColor) },
        });
      }
      // Set data
      // https://www.amcharts.com/docs/v5/charts/flow-charts/#Setting_data
      series.nodes.data.setAll(
        wasteNodesData.concat(resultNodesData).concat(lastNodesData)
      );
      series.data.setAll(wasteData.concat(resultData));

      // Make stuff animate on load
      series.appear(1000, 1000);

      // loadingのskeltonを非表示
      this.loading = false;
    },
    async generatePDF() {
      // 印刷範囲の要素を取得
      const element = document.getElementById("productAnalysisDetail");

      try {
        // HTML要素をCanvasに変換
        const canvas = await html2canvas(element, {
          scale: 2, // 高解像度でキャプチャ
          backgroundColor: "#ffffff", // 背景色
          proxy: "https://staging-html2canvas-proxy.circular-insight.com/proxy", // CORS対応のプロキシを指定
          onclone: (clonedDocument) => {
            // ここでクローンされたDOMを操作
            // サンキー図の親要素を取得
            const parentElement = clonedDocument.querySelector("#chartdiv");
            // サンキー図の親要素内のcanvasタグを取得
            const chartDivCanvas = parentElement.querySelector("canvas");
            // chartdivのcanvasのwidthをpdf用に変更
            if (chartDivCanvas) {
              chartDivCanvas.style.width = "1495px";
            }
          },
        });

        // Canvasを画像データに変換
        const imgData = canvas.toDataURL("image/png");

        // jsPDFでPDFを生成
        const pdf = new jsPDF("p", "mm", "a4");
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = pdf.internal.pageSize.getHeight();
        const imgWidth = canvas.width;
        const imgHeight = canvas.height;
        const ratio = pdfWidth / imgWidth;
        const scaledHeight = imgHeight * ratio;

        let yOffset = 0;
        while (yOffset < scaledHeight) {
          pdf.addImage(imgData, "PNG", 0, -yOffset, pdfWidth, scaledHeight);
          yOffset += pdfHeight;

          if (yOffset < scaledHeight) {
            pdf.addPage(); // 次のページを追加
          }
        }

        // PDFを保存
        await pdf.save(
          "レポート詳細_#" +
            this.report.id +
            "_" +
            this.report.info.name +
            ".pdf"
        );
      } catch (error) {
        console.error("Error generating PDF:", error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.product-analysis-detail {
  background: #f4f8ff;
  padding: 20px;
}
.product-analysis-detail-title {
  height: 68px;
  font-family: "SF Pro";
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 32px;
  letter-spacing: 0.15px;
  color: #000000;
}
.icon-close {
  width: 36px;
  height: 36px;
  align-self: center;
}
.carousel {
  width: 446px !important;
}
.font-title {
  font-weight: 600;
  font-size: 34px;
  line-height: 42px;
}
.card-text {
  text-align: end;
}
.report-no {
  font-weight: 400;
  font-size: 13px;
  line-height: 18px;
  color: #697077;
}
.tabs {
  width: 300px;
}
.tab {
  width: 150px;
  font-size: 14px;
  font-weight: 510;
  line-height: 20px;
}
.chip-in-progress {
  background: linear-gradient(
      0deg,
      rgba(255, 255, 255, 0.88),
      rgba(255, 255, 255, 0.88)
    ),
    #0e5df0 !important;
  border-radius: 16px !important;
  color: #2ad000 !important;
}
.chip-pending {
  background: linear-gradient(
      0deg,
      rgba(255, 255, 255, 0.88),
      rgba(255, 255, 255, 0.88)
    ),
    #0e5df0 !important;
  border-radius: 16px !important;
  color: #ffa800 !important;
}
.v-select__slot {
  height: auto !important;
}
.images {
  width: 40px;
  height: 40px;
  margin-inline: auto;
}
.slide-items {
  max-width: 120px;
  margin-inline: auto;
}
.sample {
  font-weight: bold;
  font-size: 16px;
  line-height: 26px;
  width: 160px;
  height: 40px;
}
.base_container {
  width: 100%;
  height: 700px;
  background-color: #ffffff;
}
.justify-self-center {
  justify-self: center;
}
.width-100 {
  width: 100%;
}
.summary_top {
  display: grid;
  padding: 15px 15px;
  grid-template-columns: 1fr 1fr;
  height: 60px;
}
.summary_bottom {
  border-top: solid 1px rgba(52, 58, 63, 0.1);
  display: flex;
  justify-content: space-evenly;
  padding: 20px 25px;
}
.summary_text {
  font-family: "SF Pro";
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 32px;
  letter-spacing: 0.15px;
  color: #000000;
}
#chartdiv {
  width: 100%;
  height: calc(100% - 60px);
}
</style>
